import React from 'react'
import PropTypes from 'prop-types'

const ButtonComponent = ({
  type = 'button',
  color = 'primary',
  width = '',
  onClick,
  children,
  hidden = false,
  disabled = false
}) => {
  return (
    <button
      type={type}
      className={`btn btn-${color} mt-1 ${width} ${hidden ? 'd-none' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

ButtonComponent.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default ButtonComponent